'use client';

import React, { createContext, useEffect, useState } from 'react';

type UtmParamsProviderType = {
  values: Record<string, string>;
}

const Context = createContext({} as UtmParamsProviderType);

export const UtmParamsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [values, setValues] = useState<Record<string, string>>({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utmParams = Array.from(params.keys())
      .filter((key) => key.startsWith('utm_'))
      .reduce((acc, key) => {
        acc[key] = params.get(key) || '';
        return acc;
      }, {} as Record<string, string>);

    if (Object.keys(utmParams).length > 0) {
      Object.keys(utmParams).forEach((key) => {
        const expires = new Date();
        expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000);
        document.cookie = `${key}=${utmParams[key]}; path=/; expires=${expires.toUTCString()}`;
      });
      setValues(utmParams);
    } else {
      const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
        const [key, value] = cookie.split('=');
        if (key.startsWith('utm_')) {
          acc[key] = value;
        }
        return acc;
      }, {} as Record<string, string>);
      setValues(cookies);
    }
  }, []);

  return (
    <Context.Provider value={{ values }}>
      {children}
    </Context.Provider>
  );
};

export const useUtmParams = () => React.useContext(Context);
